import { ref, computed, toRaw } from "vue";
import { defineStore } from "pinia";

import { fetchMyMeasures, fetchAllMyAlerts, postNewAlertMessage, setAlertViewed, fetchWidgetSummarylist } from "../api/workListsApi";

import { toast } from "vue3-toastify";

// * STOREs
import { useUsersPatientsStore } from "@/stores/usersPatientStore";

import moment from "moment";

import { extendMoment } from "moment-range";
import { faThemeisle } from "@fortawesome/free-brands-svg-icons";

import Vue from "vue";

// var moment = extendMoment(momentJ);

interface ITaskRecord {
  uniqueId: string;
  type: string;
  description: string;
  id: number;
  sourceId: number;
  containerId: number;
}

interface IState {
  taskRecords: ITaskRecordsMap;
}

interface ITaskRecordsMap {
  [taskRecordsSource: string]: ITaskRecord[];
}

interface ITasksPayload {
  sourceId: number;
  tasks: ITaskRecord[];
}

const taskRecords: ITaskRecordsMap = {};
const state: IState = {
  taskRecords,
};
const uniqueId = (payload: ITaskRecord) => `${payload.sourceId}-${payload.id}`;

export const useStoreWorkList = defineStore("workListStore", {
  state: () => {
    return {
      primaryWidgetSummaryList: [],
      workWidgetSummaryList: [],
      diseaseWidgetSummaryList: [],
      currentSelectedSummaryWidget: {},
      currentSelectedWorkSummaryWidget: {},
      widgetArray: [],
      workwidgetArray: [],
      selectedWidgetDetail: {},

      loadingPanelVisible: false,

      taskRecords,
      allMyAlerts: [],
      allMyAlertsTabs: [],
      allMyAlertsNotViewedQty: 0,

      showOutsideLSB: true,
      isOutsideLSBOpen: false,

      widgetTaskFilters: {
        id: 0,
        selected: [],
        selectedTaskFilters: [],
        taskTypeOptions: [
          // { value: 'Select All', text: 'Select All' },
          { value: "Dropped HCC Codes", text: "Dropped HCC Codes" },
          { value: "Not Coder Validated", text: "Not Validated by Coder" },
          { value: "Not Clin. Validated", text: "Not Validated by Clinician" },
          { value: "New Codes Not Used", text: "Added Not Used" },
          { value: "Chart Review Needed", text: "Charts Not Reviewed" },
          { value: "Tasks", text: "Tasks" },
          { value: "Message", text: "Message" },
          { value: "Coding", text: "Coding" },
          { value: "Patient", text: "Patient" },
          { value: "Pharmacy", text: "Pharmacy" },
          { value: "Orders", text: "Orders" },
          { value: "General", text: "General" },
          { value: "Scheduling", text: "Scheduling" },
          { value: "Reminder", text: "Reminder" },
        ],
      },
      widgetPrimaryFilters: {
        priorityOptions: [
          // { value: 'Select All', text: 'Select All' },
          { value: 1, text: "High" },
          { value: 2, text: "Medium" },
          { value: 3, text: "Low" },
        ],
      },
      widgetWorkFilters: {
        priorityOptions: [
          // { value: 'Select All', text: 'Select All' },
          { value: 1, text: "High" },
          { value: 2, text: "Medium" },
          { value: 3, text: "Low" },
        ],
      },
      selectedWidgetFilter: "",
      devFilters: {
        InPatientIDs: false,
        COMMsIDs: false,
        MeasuresIDs: false,
        DxRecordDetailsIDs: false,
        ResultsSummaryIDs: false,
        ResultsFormIDs: false,
        GenericChartIDs: false,
        ProblemListRecordSelectorIDs: false,
        SecurityGroupIsVisible: false,
        usersVariant: "info",
      },

      // * All my work SECTION
      // allMyWork: [],
      // allMyWorkTOTAL: 0,
      // allMyWorkOVERDUEQty: 0,
      // allMyWorkDUESoonQty: 0,
      // allMyWorkHighPriorityQty: 0,
      // allMyWorkMediumPriorityQty: 0,
      // allMyWorkLowPriorityQty: 0,

      // allMyWorkT: [],

      // allMyDelegatedWork: [],
      // allMyDelegatedWorkTOTAL: 0,
      // allMyDelegatedWorkOVERDUEQty: 0,
      // allMyDelegatedWorkDUESoonQty: 0,
      // allMyDelegatedWorkHighPriorityQty: 0,
      // allMyDelegatedWorkMediumPriorityQty: 0,
      // allMyDelegatedWorkLowPriorityQty: 0,

      // allMyOtherWork: [],
      // allMyOtherWorkTOTAL: [],
      // allMyOtherWorkOVERDUEQty: 0,
      // allMyOtherWorkDUESoonQty: 0,
      // allMyOtherWorkHighPriorityQty: 0,
      // allMyOtherWorkMediumPriorityQty: 0,
      // allMyOtherWorkLowPriorityQty: 0,

      // allMyAssignedWork: [],
      // allMyAssignedWorkTOTAL: [],
      // allMyAssignedWorkOVERDUEQty: 0,
      // allMyAssignedWorkHighPriorityQty: 0,
      // allMyAssignedWorkMediumPriorityQty: 0,
      // allMyAssignedWorkLowPriorityQty: 0,

      allMyMeasures: [],
      allMyMeasuresQty: 0,
      allMyMeasuresINCQty: 0,
      allMyMeasuresNearCompQty: 0,

      // allMyAlerts: [],
      // allMyAlertsTabs: [],
      // allMyAlertsNotViewedQty: 0,

      // droppedHCCTOTAL: 0,
      // droppedHCCoverdueQty: 0,
      // droppedHCCdueSoonQty: 0,
      // droppedHCCHighPriorityQty: 0,
      // droppedHCCMediumPriorityQty: 0,
      // droppedHCCLowPriorityQty: 0,

      // coderTOTAL: 0,
      // coderOVERDUEQty: 0,
      // coderDueSoonQty: 0,
      // coderHighPriorityQty: 0,
      // coderMediumPriorityQty: 0,
      // coderLowPriorityQty: 0,

      // clinicianTOTAL: 0,
      // clinicianOVERDUEQty: 0,
      // clinicianDueSoonQty: 0,
      // clinicianHighPriorityQty: 0,
      // clinicianMediumPriorityQty: 0,
      // clinicianLowPriorityQty: 0,

      // delegatedWork: {
      //   patients: [],
      //   filterItems: [],
      //   activeFilter: 'Select All',
      // },
      // myWork: {
      //   patients: [],
      //   filterItems: [],
      //   activeFilter: 'Select All',
      // },
      // myOtherWork: {
      //   patients: [],
      //   filterItems: [],
      //   activeFilter: 'Select All',
      // },
      // currentDate: moment(Date.now()).format('YYYY-MM-DD'),
      usersFilters: {
        userSelectedDate: "2021-10-15",
        dateRanges: 0,
        taskTypes: "Select All",
        taskPriority: 99,
        patientStatus: "Select All",
        selectedDateRange: { start: "", end: "" },
        useCurrentDateFilter: false,
        // useTaskFilter: false,
      },

      patientFilters: {
        lastSeen: 0,
        nextAppt: 0,
        selectedLastSeenDateRange: { start: "", end: "" },
        selectedNextApptDateRange: { start: "", end: "" },
      },
      measuresFilters: {
        providerName: null,
        providerNamesList: [],
        selectedContractMeasDetails: [],
        selectedContractMeasFileName: "",
        filteredContractMeasDetails: [],
        measuresYear: "2023",
        measuresYearsList: ["2023", "2022"],
        useCurrentStatusFilter: "Y",
        showAllMeasures: false,
        showAllMeasuresCompletedPatients: false,
        isMeasuresStatusComplete: true,
      },
    };
  },
  actions: {
    async getAllMyMeasuresStoreToAPI() {
      // console.log(' WORKLIST STORE >  getAllMyMeasuresStoreToAPI ')
      // console.log('                   api from ./workListsApi                      >>   fetchMyMeasures')
      const result = await fetchMyMeasures();
      // // // console.log(' wrkSTR getAllMyStoreToAPI')
      // // // console.log('   STORE   result: >>>>>>>>>>>>>>>>>')
      // // // console.log(     result)
      //

      if (result.ok) {
        // // // console.log('done...    RUN commit  setAllMyMeasures')
        // commit('setAllMyMeasures', result.payload)
        this.setAllMyMeasures(result.payload);
      }
      return result;
    },
    async getAllMyAlertsStoreToAPI() {
      // console.log(" WORKLIST STORE >  getAllMyAlertsStoreToAPI          fetchAllMyAlerts");
      const result = await fetchAllMyAlerts();
      // console.log("                                 STORE  fetchAllMyAlerts  result: >>>>>>>>>>>>>>>>>");
      // console.dir(result);
      if (result.ok) {
        // console.log("                 done...    RUN commit  setAllMyAlerts");
        // commit('setAllMyAlerts', result.payload)

        this.setAllMyAlerts(result.payload);
      }
      return result;
    },
    async postNewAlertMessage(payload) {
      // // console.clear()
      // // console.log('payload')
      // // console.dir(payload)
      // // console.log('      POST  NEW  ALERT MESSAge llllllllllll  wrk STORE    >   postNewAlertMessage   ')
      const result = await postNewAlertMessage(payload);
      // // console.log('Result ')
      // // console.log(result)

      if (result.ok) {
        this.setAllMyAlerts(result.payload);
      }
      return result;
    },
    // & .> PostAlertViewed
    async setPostAlertViewed(id) {
      // // console.clear()
      // // console.log('       setPostAlertViewed  ')
      // // console.log('id')
      // // console.log(id)
      const result = await setAlertViewed(id.id);
      if (result.ok) {
        // // console.log(' res.ok payload')
        // // console.log(result.payload)
        // & set the SINGLE ?

        // // commit('getAllMyAlertsStoreToAPI')
        // state.allMyAlerts = []
        // dispatch("getAllMyAlertsStoreToAPI");
        this.getAllMyAlertsStoreToAPI();
        // // commit('setMyWork', result.payload)
      }
      return null;
    },
    setAllMyAlerts(payload) {
      // // console.clear()
      // console.log(" setAllMyAlerts             >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>     WRK str  SET allMyAlerts ");
      // console.dir(payload);
      this.allMyAlerts = payload.messages;
      this.allMyAlertsTabs = payload.tabs;
      this.allMyAlertsNotViewedQty = this.allMyAlerts.filter((com) => !com.viewed).length;
    },
    async getWidgetSummaryListFromAPI() {
      // // console.clear()
      // console.log(">>>>>>>>>>>>> STORE workList :   getWidgetSummaryListFromAPI");

      const result = await fetchWidgetSummarylist();

      // * CONSUME the 3 arrays ONCE received

      // // console.log('                       API fetchWidgetSummarylist')

      // console.log("Result ");
      // console.log(result);

      if (result.ok) {
        // console.log(" TODO >>>>>>>>>>>> COMMITTING :           setWidgetSummaryList , result.payload ..................");
        // commit('setWidgetSummaryList', result.payload)

        // commit("setWidgetSummaryList", result.payload);
        this.setWidgetSummaryList(result.payload);
      }
      return result.payload;
    },
    setWidgetSummaryList(widgetSummaryListINC) {
      // // console.clear()
      // // console.log(" >>>>>>>>>>>>>>                             STR: setWidgetSummaryList : ");
      this.primaryWidgetSummaryList = widgetSummaryListINC.widgetGroups[0].widgetSummaryItem;
      this.workWidgetSummaryList = widgetSummaryListINC.widgetGroups[1].widgetSummaryItem;
      this.diseaseWidgetSummaryList = [];

      // console.log("***************************************************************************************************************");
      // // console.log("***************************************************************************************************************");
      // console.log("  SETTING  PRIMARY >>>  currentSelectedSummaryWidget  <<<<<<<<");

      // toast.info("Worklist STORE :  Setting currentSelectedSummaryWidget  = NOT CLINICIAN ")
      this.currentSelectedSummaryWidget = this.primaryWidgetSummaryList[1];

      // toast.info("Worklist STORE :  Setting currentSelectedSummaryWidget  = NOT CODER for TESTING  ")
      // this.currentSelectedSummaryWidget = this.primaryWidgetSummaryList[2];

      // console.log("  SETTING   setWidgetArray  <<<<<<<<");
      this.setWidgetArray(this.currentSelectedSummaryWidget.widgetGridDataArray);
      // // console.log(this.currentSelectedSummaryWidget);

      // console.log("  SETTING WORK >>>>  currentSelectedWorkSummaryWidget  <<<<<<<<");
      this.currentSelectedWorkSummaryWidget = this.workWidgetSummaryList[0];
      // console.log("  SETTING   setWorkWidgetArray    <<<<<<<<");
      this.setWorkWidgetArray(this.currentSelectedWorkSummaryWidget.widgetGridDataArray);
      // // console.log(this.currentSelectedWorkSummaryWidget);

      // console.log('  TOGGLE LOAD PANEL')
      if (this.loadingPanelVisible) {
        this.toggleLoadPanel();
      }
    },
    setSelectedSummaryWidget(selectedWidget) {
      // // console.clear()
      // console.log(" STR: setSelectedSummaryWidget : ");
      // // // console.log('                 setSelectedSummaryWidget            888888888888888888888888888                  selectedWidget ')
      // // console.dir(selectedWidget)
      // // console.dir(JSON.parse(selectedWidget))

      // if (state.currentSelectedSummaryWidget === null) {
      //   state.currentSelectedSummaryWidget = state.primaryWidgetSummaryList[0]
      // }else{
      // * JSON PARSE for OBJECT Binding FIX
      this.currentSelectedSummaryWidget = JSON.parse(selectedWidget);
      // // console.log('               tate.currentSelectedSummaryWidget : ')
      // // console.log(state.currentSelectedSummaryWidget)
      // }
    },
    setSelectedWorkSummaryWidget(selectedWidget) {
      // // console.clear()
      // console.log(" STR:         WORK widget   setSelectedWorkSummaryWidget : ");
      // // console.log('JSON.parse(selectedWidget)')
      // // console.log(JSON.parse(selectedWidget))
      this.currentSelectedWorkSummaryWidget = JSON.parse(selectedWidget);
    },
    setSelectedSummaryWidgetDetail(state, selectedWidgetDetail) {
      // console.clear();
      // console.log("33333333333333333333333333333333333333333 STR: setSelectedSummaryWidgetDetail : ");
      // // console.log(selectedWidgetDetail)
      this.selectedWidgetDetail = selectedWidgetDetail;
      // // console.log('                   state.selectedWidgetDetail ')
      // console.log(this.selectedWidgetDetail);
    },

    setWidgetArray(array) {
      // // console.clear()
      // console.log("    wek STORE   setWidgetArray  ");
      // console.log(array);
      this.widgetArray = array;
    },
    setWorkWidgetArray(array) {
      // // console.clear()
      // console.log("    wek STORE   setWorkWidgetArray  ");
      // console.log(array);
      this.workwidgetArray = array;
    },

    filterPrimaryWidgetGrid(widgetFilters) {
      // // console.clear()
      // console.log("   STORE COMMIT: filterPrimaryWidgetGrid");

      // console.log(widgetFilters);

      if (widgetFilters.length == 0) {
        this.widgetArray = this.currentSelectedSummaryWidget.widgetGridDataArray;
      } else {
        this.widgetArray = this.currentSelectedSummaryWidget.widgetGridDataArray.filter((person) => {
          // // console.log('person.priority: ' , person.priority + ' ' + widgetFilters.includes(person.priority))
          // // console.log(widgetFilters)
          // // console.log(widgetFilters.value.includes(person.priority))
          // // console.log({...props.widget});
          if (widgetFilters.value.includes(person.priority)) {
            return person;
          }
        });
      }

      // console.log("  FOUND :  ");
      // console.dir(this.widgetArray);
      // // // console.log('  FOUND :  ')
      // console.log(this.widgetArray.length);

      // // // console.dir(found)
      return this.widgetArray;
    },
    filterWidgetGrid(widgetFilters) {
      // // console.clear()
      // console.log("       filterWidgetGrid                                             STORE COMMIT: filterWidgetGrid");
      if (widgetFilters.length == 0) {
        this.workwidgetArray = this.currentSelectedWorkSummaryWidget.widgetGridDataArray;
        // console.log(" RET:  workwidgetArray  " + this.workwidgetArray.length);
      } else {
        this.workwidgetArray = this.currentSelectedWorkSummaryWidget.widgetGridDataArray.filter((person) => {
          if (person.tasks.some((task) => widgetFilters.includes(task.taskType))) {
            return person.tasks.filter((task) => widgetFilters.includes(task.taskType));
          } else {
            // // // console.log(' ELSE >>> ')
            // return person.tasks
            // return person.tasks.filter( (task) =>  widgetFilters.includes(task.taskType)    )
          }

          if (widgetFilters.includes(person.priority)) {
            return person;
          }

          // console.log(" return   FILTERED:  QTY :  " + this.workwidgetArray.length);
        });
      }

      // console.log("  FOUND workwidgetArray  :  ");
      // console.dir({ ...this.workwidgetArray });

      // console.log("  FOUND workwidgetArray  toRAW():  ");
      // console.dir(toRaw(this.workwidgetArray));

      // console.log("  FOUND :  ");
      // console.log(this.workwidgetArray.length);

      // // // console.dir(found)
      return this.workwidgetArray;
    },

    setWidgetPrimaryFilters(widgetFilt) {
      // console.clear();
      // console.log("             PRIMARY              STR setWidgetPrimaryFilters   ");
      // console.log("     ");
      // console.log(widgetFilt);
      this.widgetPrimaryFilters.selected = widgetFilt;
    },
    setWidgetWorkFilters(widgetFilt) {
      // // console.clear();
      // console.log("                WORK           STR setWidgetWorkFilters   ");
      // // console.log('     ')
      // console.log(widgetFilt);
      this.widgetWorkFilters.selected = widgetFilt;
    },
    setWidgetTaskFilters(widgetFilt) {
      // // console.clear()
      // console.log("                    setWidgetTaskFilters                 selectedTaskTypeFilters             STR setWidgetTaskFilters   ");
      // console.log(toRaw(widgetFilt));

      // console.log(' CHECK  widgetTaskFilters')
      // console.log(this.widgetTaskFilters)

      this.widgetTaskFilters.id = widgetFilt.curSId;
      this.widgetTaskFilters.selected = widgetFilt.curSTaskFilter;
      this.widgetTaskFilters.selectedTaskFilters = widgetFilt.curSTaskFilter;

      if (widgetFilt.curSTaskFilter == undefined || !widgetFilt.curSTaskFilter) {
        this.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters = widgetFilt.curSTaskFilter = [];
      } else {
        // console.log("BINDing  inc ARRAY");
        this.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters = widgetFilt.curSTaskFilter;
      }

      // ^ ? Find current workWidSunList by widgetRFilt.id
    },
    clearSelectedWidgetTaskFilters(state) {
      // // console.log(' STR  clearSelectedWidgetTaskFilters')
      // // console.log(state.widgetTaskFilters)
      this.widgetTaskFilters.selected = [];
      this.widgetTaskFilters.selectedTaskFilters = [];
    },

    toggleLoadPanel() {
      this.loadingPanelVisible = !this.loadingPanelVisible;
    },
    toggleMeasuresStatusComplete() {
      this.measuresFilters.isMeasuresStatusComplete = !this.measuresFilters.isMeasuresStatusComplete;
    },
    setWIdgetFilter(payload) {
      // // console.clear()
      // console.log("     STORE           setWIdgetFilter ");
      // console.log(payload);

      this.selectedWidgetFilter = payload;
    },
    reSetWIdgetFilter(payload) {
      this.selectedWidgetFilter = "";
    },

    setAllMyMeasures(allMyMeasures) {
      // // // console.log(' >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>     WRK str  SET Measures ')
      this.allMyMeasuresROOT = allMyMeasures[0];
      this.allMyMeasures = allMyMeasures[0].contractMeasureSummaries;
      this.measuresFilters.providerNamesList = allMyMeasures[0].providers;
      // // // console.log(' pName')
      // // // console.log(allMyMeasures.providers[0])
      // // // console.log( this.measuresFilters.providerNamesList)

      // // // console.log(this.measuresFilters.providerNamesList[0])
      this.measuresFilters.providerName = this.measuresFilters.providerNamesList[0];
      // // // console.log('PRE name ' + this.measuresFilters.providerName)
      this.measuresFilters.measureYears = allMyMeasures.measureYears;

      // ^ set counts
      this.allMyMeasuresQty = this.allMyMeasures.filter((com) => com.measureStatus).length;
      this.allMyMeasuresINCQty = this.allMyMeasures.filter((com) => com.measureStatus === "1").length;
      this.allMyMeasuresNearCompQty = this.allMyMeasures.filter((com) => com.measureStatus === "2").length;

      // console.log('this.allMyMeasures')
      // console.dir(this.allMyMeasures )
      // // // console.log('INC Qty: ' + state.allMyMeasuresINCQty )
      // // // console.log('Near Comp Qty: ' + state.allMyMeasuresNearCompQty )
      // // // console.log('_________________________')
      // // // console.log('WRK str  SET Measures ')
    },
    setCurrentContractMeasuresDetails(currentContractDetails) {
      // console.log('    STORE      setCurrentContractMeasuresDetails')
      // // console.log(' currentContractDetails')
      this.measuresFilters.selectedContractMeasDetails = currentContractDetails;
    },

    setCurrentContractMeasuresDetailFileName(currentFileName) {
      // // console.clear()
      // console.log('                            STORE      setCurrentContractMeasuresDetail         FileName')
      // console.log(' currentFileName')
      // console.log(currentFileName)
      this.measuresFilters.selectedContractMeasFileName = currentFileName;
    },

    // * dash task records

    addDashTaskRecords(payload: ITasksPayload) {
      if (!payload.tasks || payload.tasks.length === 0) {
        // Vue.delete(state.taskRecords, payload.sourceId)
        delete this.taskRecords[payload.sourceId];
      }

      // console.log('     >>>     >>>     >>>     >>>     >>>                                addDashTaskRecords > workLIst STORE')
      // console.log('taskRecords:')
      // console.dir(this.taskRecords)
      // console.log('   payload: ')
      // console.dir(payload)
      // console.log('   payload.sourceId: ', payload.sourceId)
      // console.log(' payload.tasks []')
      // console.dir(payload.tasks)

      // Vue.set(state.taskRecords, payload.sourceId, payload.tasks)
      this.taskRecords[payload.sourceId] = payload.tasks;
    },
    clearDashTaskRecords(state) {
      this.taskRecords = [];
    },
  },
  getters: {
    getDEVFilters: (state) => state.devFilters,
    getAllDashTaskRecords: (state: IState) => {
      // console.log('getAllDashTaskRecords')
      // console.log('Object.values(state.taskRecords).flat()')
      // console.log(Object.values(state.taskRecords).flat())
      // // console.log(Object.values(taskRecords).flat())
      return Object.values(state.taskRecords).flat();
    },
    getDashTaskRecordsForSource: (state: IState) => (sourceId: number) => {
      // console.log(' WorkList Store  getDashTaskRecordsForSource   ')
      // console.log('sourceId : ' + sourceId)

      return state.taskRecords[sourceId] || [];
    },
    // & NEW GETT ER test
    // getUserById: (state) => {
    //   return (userId) => state.users.find((user) => user.id === userId)
    // },

    getWidgetById: (state) => {
      // console.log(" P STR     getWidgetById");
      // console.log("currentSelId");

      return (currentSelId) =>
        state.workWidgetSummaryList.find((widget) => {
          // console.log(currentSelId);

          return widget.id === currentSelId;
        });
    },

    getMyWorkTaskRecords: (state) => state.taskRecords[8],
    getMyDelegatedWorkTaskRecords: (state) => state.taskRecords[9],
    getMyOtherWorkTaskRecords: (state) => state.taskRecords[3],
    getMyAssignedWorkTaskRecords: (state) => state.taskRecords[15],
    getCodingTaskRecords: (state) => state.taskRecords[0],
    getMeasuresTaskRecords: (state) => state.taskRecords[61],

    // getMyWorkTaskCount: (state) => state.taskRecords[8].length,
    // getMyDelegatedWorkTaskCount: (state) => state.taskRecords[9].length,
    // getMyOtherWorkTaskCount: (state) => state.taskRecords[3].length,
    // getMyAssignedWorkTaskCount: (state) => state.taskRecords[15].length,

    // * FILTERS
    getUsersFilters: (state) => state.usersFilters,
    getPatientFilters: (state) => state.patientFilters,
    getContractMeasuresFilters: (state) => state.measuresFilters,
    selectedProvider: (state) => state.measuresFilters.providerName,
    // widgetTaskFilters: (state) => state.widgetTaskFilters,
    // widgetPrimaryFilters: (state) => state.widgetPrimaryFilters,
    widgetWorkFilters: (state) => state.widgetPrimaryFilters,

    showOutsideLSB: (state) => state.showOutsideLSB,
    isOutsideLSBOpen: (state) => state.isOutsideLSBOpen,

    // * FILTERS selectedContractMeasDetails
    filteredContractMeasDetails: (state) =>
      (state.measuresFilters.filteredContractMeasDetails = state.measuresFilters.selectedContractMeasDetails.filter(function (person) {
        if (!state.measuresFilters.showAllMeasuresCompletedPatients) {
          return person.status === "N";
        } else {
          return person.status;
        }
      })),
  },
});
